var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconPictures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.312 18.75c.932 0 1.688-.756 1.688-1.688V6.938c0-.932-.756-1.688-1.688-1.688H4.688C3.756 5.25 3 6.006 3 6.938v10.124c0 .932.756 1.688 1.688 1.688h14.624zm-.21-1.688H4.898c-.116 0-.21-.094-.21-.21V7.148c0-.116.094-.21.21-.21h14.204c.116 0 .21.094.21.21v9.704c0 .116-.094.21-.21.21zM7.5 11.156c.777 0 1.406-.63 1.406-1.406 0-.777-.63-1.406-1.406-1.406-.777 0-1.406.63-1.406 1.406 0 .777.63 1.406 1.406 1.406zm10.125 4.219v-2.813l-3.077-3.076c-.164-.165-.432-.165-.596 0L9.75 13.687l-1.39-1.389c-.164-.164-.431-.164-.596 0l-1.389 1.39v1.687h11.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconPictures);
export default __webpack_public_path__ + "static/media/elements-icon-pictures.af415c2cc2297b5fdf3a52732bb2992f.svg";
export { ForwardRef as ReactComponent };